import { fileInputWithPreview } from '@helpers'

$(function() {
  if ($('#meals-create').length === 0 && $('#meals-edit').length === 0) return

  fileInputWithPreview('#file', '#preview', '#preview')

  // validate time input
  $('#time').keyup(function() {
    if (moment($('#time').val(), 'H:mm', true).isValid()) {
      $('#time-error').hide()
      $('#btn-submit').attr('disabled', false)
    } else {
      $('#time-error').show()
      $('#btn-submit').attr('disabled', true)
    }
  })

  // show last_meal checkbox only today
  if (moment($('#date').val()).isSame(new Date(), "day")) {
    $('#last-meal-box').show()
  }
})
